import React, { useEffect, useState } from 'react'
import Footer from '../component/Footer';
import api from '../api';

const PrivacyPolicy = () => {
    const [policy, setPolicy] = useState([]);
    const [isVisible, setIsVisible] = useState(false);

    const getPrivacyPolicy = async () => {
        try {
            const storedData = localStorage.getItem("userData");
            const token = storedData ? JSON.parse(storedData).token : null;
            const res = await api.get("/user/policy_and_terms", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }, params: {
                    type: "privacy-policy",
                    lang: "en",
                },
            }
            );
            setPolicy(res.data);


        } catch (error) {
            console.log("error", error.message);
        }
    }
    useEffect(() => {
        getPrivacyPolicy();
    }, []);
   
   useEffect(() => {
           window.scrollTo({ top: 0, behavior: 'auto' });
   
           const toggleVisibility = () => {
               if (window.pageYOffset > 300) {
                   setIsVisible(true);
               } else {
                   setIsVisible(false);
               }
           };
   
           window.addEventListener('scroll', toggleVisibility);
   
           return () => {
               window.removeEventListener('scroll', toggleVisibility);
           };
       }, []);
    return (
        <>
            <div className="container-fluid mt-5 mb-5">

                <div>
                    <h3 className='mt-5 text-center'>{policy?.data?.title}</h3>
                    <p
                        className="mt-5"
                        dangerouslySetInnerHTML={{ __html: policy?.data?.content || '' }}
                    ></p>

                </div>


            </div>

            <Footer />
        </>
    )
}

export default PrivacyPolicy;
